import { render } from "./PermissionCheckEditor.vue?vue&type=template&id=3a1b2f53&ts=true"
import script from "./PermissionCheckEditor.vue?vue&type=script&lang=ts"
export * from "./PermissionCheckEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__